import { Save } from "lucide-react";
import { useState } from 'react';

const CreateRoomModal = ({ onClose, onAddRoom }) => {
    // State for form data
    const [formData, setFormData] = useState({
        roomName: '',
        location: '',
        comment: ''
    });
    const [errorMsg, setErrorMsg] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMsg('');

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/settings/addRoom`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });

            const data = await response.json().catch(() => ({}));

            if (!response.ok) {
                const msg = data.error || 'Nie udało się dodać sali.';
                setErrorMsg(msg);
                return;
            }

            onAddRoom(data);

            setFormData({ roomName: '', location: '', comment: '' });

            onClose();
        } catch (error) {
            console.error('Error creating room:', error);
            setErrorMsg('Błąd połączenia. Spróbuj ponownie.');
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3 className="modal-title">Dodaj Sale</h3>
                {errorMsg && (
                    <p style={{ color: '#b91c1c', fontSize: '0.9rem', marginBottom: '0.75rem' }}>{errorMsg}</p>
                )}
                <form>
                    <div className="form-group">
                        <label>Nazwa Sali:</label>
                        <input
                            className="form-input"
                            type="text"
                            name="roomName"
                            value={formData.roomName}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group">
                        <label>Lokalizacja:</label>
                        <input
                            className="form-input"
                            type="text"
                            name="location"
                            value={formData.location}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group">
                        <label>Komentarz:</label>
                        <input
                            className="form-input"
                            type="text"
                            name="comment"
                            value={formData.comment}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="modal-actions">
                        <button onClick={onClose} className="button-secondary">Anuluj</button>
                        <button onClick={handleSubmit} className="button-primary">
                            <Save size={16} />
                            <span>Zapisz</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default CreateRoomModal;